var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index",class:[_vm.isDarkmode ? 'is-darkmode' : 'is-lightmode']},[_c('container-main-menu'),_c('container-app-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }